import { useMemo } from 'react';

import {
  PROPERTY_REPORT_SECTION_ORDER_DEFAULT,
  PROPERTY_REPORT_SECTION_ORDER_PROFESSIONAL,
} from 'components/reports/propertyReportSections/propertyReportSectionOrder.constants';

import type { PropertySectionKey } from 'components/reports/propertyReportSections/propertySectionKeys';

/** Which property report layout to order sections for (UPS-1260/UPS-1261). */
export type PropertyReportSectionView = 'default' | 'professional';

export interface UsePropertyReportSectionOrderArgs {
  /**
   * Which view's section order to return. Defaults to `'default'` (the
   * homebuyer view, unchanged from today). Pass `'professional'` once the
   * caller has resolved the user's persona/layout choice.
   */
  view?: PropertyReportSectionView;
}

/**
 * Returns the ordered list of `PropertySectionKey`s to render for the
 * property report, based on the requested view.
 *
 * @example
 * ```tsx
 * const sectionOrder = usePropertyReportSectionOrder({ view: 'professional' });
 * ```
 */
export const usePropertyReportSectionOrder = ({
  view = 'default',
}: UsePropertyReportSectionOrderArgs = {}): PropertySectionKey[] =>
  useMemo(
    () =>
      view === 'professional'
        ? PROPERTY_REPORT_SECTION_ORDER_PROFESSIONAL
        : PROPERTY_REPORT_SECTION_ORDER_DEFAULT,
    [view]
  );
